export const hasValue = <T>(object: T | undefined | null): object is T =>
    object !== undefined && object !== null
